import { useEffect, useMemo, useState } from 'react'
import Particles from '@tsparticles/react'
import { type ISourceOptions } from '@tsparticles/engine'
import { ensureParticlesEngine } from '../particles/engine'
import { useEffects } from '../contexts/EffectsContext'

const ParticlesBackground = () => {
	const [init, setInit] = useState(false)
	const { effects } = useEffects()

	useEffect(() => {
		ensureParticlesEngine().then(() => {
			setInit(true)
		})
	}, [])

	const options: ISourceOptions = useMemo(
		() => ({
			background: {
				// Transparent so the themed page background (CSS variable)
				// shows through — keeps light/dark theme switching working.
				color: {
					value: 'transparent',
				},
			},
			fpsLimit: 60,
			interactivity: {
				events: {
					onClick: {
						enable: true,
						mode: 'push',
					},
					onHover: {
						enable: true,
						mode: 'repulse',
					},
				},
				modes: {
					push: {
						quantity: 4,
					},
					repulse: {
						distance: 200,
						duration: 0.4,
					},
				},
			},
			particles: {
				color: {
					value: ['#ffffff', '#61dafb', '#ffc700', '#ff7f50', '#9acd32'],
				},
				links: {
					color: 'random',
					distance: 150,
					enable: true,
					opacity: 0.5,
					width: 1,
				},
				move: {
					direction: 'none',
					enable: true,
					outModes: {
						default: 'bounce',
					},
					random: false,
					speed: 2,
					straight: false,
				},
				number: {
					density: {
						enable: true,
					},
					value: 160,
				},
				opacity: {
					value: 0.5,
				},
				shape: {
					type: 'polygon',
					options: {
						polygon: {
							sides: 6,
						},
					},
				},
				size: {
					value: { min: 1, max: 5 },
				},
			},
			detectRetina: true,
		}),
		[],
	)

	// Effect disabled: render nothing (also stops the render loop entirely).
	if (!effects.particles || !init) {
		return <></>
	}

	return (
		<Particles
			id="tsparticles"
			options={options}
			style={{
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				zIndex: 0
			}}
		/>
	)
}

export default ParticlesBackground
